import * as React from 'react'

import NavigationDesktop from '../../components/NavigationDesktop/NavigationDesktop'
import NavigationMobile from '../../components/NavigationMobile/NavigationMobile'
import Viewport from '../../components/Viewport/Viewport'
import type { BreakingNewsItemViewModel } from '../../view-models/BreakingNewsItemViewModel'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import type { MobileMenuViewModel } from '../../view-models/MobileMenuViewModel'
import type { NavigationLogoViewModel } from '../../view-models/NavigationLogoViewModel'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import type { ServiceMenuViewModel } from '../../view-models/ServiceMenuViewModel'
import styles from './navigation-style.css'
import type { PageLoginViewModel } from './view-models/PageLoginViewModel'

type Props = {
  logo: NavigationLogoViewModel
  serviceMenu: ServiceMenuViewModel
  searchBtn?: SearchBarViewModel
  pageLinks?: Array<LinkViewModel>
  pageLogin?: PageLoginViewModel
  mobileMenuItems: MobileMenuViewModel
  backLink?: LinkViewModel
  items?: Array<BreakingNewsItemViewModel>
  header?: string
  breakingNewsLink?: LinkViewModel
  myPageLink?: LinkViewModel
  notificationCount?: string
  hideBottomDivider?: boolean
  redirectEndpoint?: string
  alignLogin?: 'right' | 'left'
}
type State = {}

class Navigation extends React.Component<Props, State> {
  static displayName = 'Navigation'
  static defaultProps = {}
  state: State = {}

  handleRedirect = (value: string) => {
    const { redirectEndpoint } = this.props

    if (redirectEndpoint && value) {
      const redirect = `${redirectEndpoint}${value}`
      global.location.assign(redirect)
    }
  }

  render() {
    const {
      logo,
      serviceMenu,
      searchBtn,
      pageLinks,
      pageLogin,
      mobileMenuItems,
      backLink,
      items,
      header,
      breakingNewsLink,
      myPageLink,
      notificationCount,
      hideBottomDivider,
        alignLogin
    } = this.props

    return (
      <header className={styles.navigation}>
        <Viewport>
          {({ isDesktop }) => (
            <React.Fragment>
              <NavigationDesktop
                hide={isDesktop === false}
                logo={logo}
                serviceMenu={serviceMenu}
                searchBtn={searchBtn}
                pageLinks={pageLinks}
                pageLogin={pageLogin}
                backLink={backLink}
                items={items}
                header={header}
                breakingNewsLink={breakingNewsLink}
                myPageLink={myPageLink}
                notificationCount={notificationCount}
                hideBottomDivider={hideBottomDivider}
                onSubmit={this.handleRedirect}
                alignLogin={alignLogin}
              />
              <NavigationMobile
                hide={isDesktop === true}
                logo={logo}
                pageLogin={pageLogin}
                pageLinks={pageLinks}
                mobileMenuItems={mobileMenuItems}
                serviceMenu={serviceMenu}
                backLink={backLink}
                items={items}
                header={header}
                breakingNewsLink={breakingNewsLink}
                searchBtn={searchBtn}
                notificationCount={notificationCount}
                myPageLink={myPageLink}
                onSubmit={this.handleRedirect}
                alignLogin={alignLogin}
              />
            </React.Fragment>
          )}
        </Viewport>
      </header>
    )
  }
}

export default Navigation